import React from 'react'

function EditPromotion() {
  return (
    <div>EditPromotion</div>
  )
}

export default EditPromotion